module.exports = __webpack_public_path__ + "img/avatar.37e36186.jpg";